import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import {
  ApplicationInsights,
  ICustomProperties,
  IEventTelemetry,
  IExceptionTelemetry,
  IPageViewTelemetry,
  ITraceTelemetry
} from '@microsoft/applicationinsights-web';

import { AppInsightsSettings } from '../../models/settings/app-insights-settings.model';

@Injectable({
  providedIn: 'root'
})
export class AzureAppInsightsService {
  private angularPlugin: AngularPlugin;
  private appInsights: ApplicationInsights;

  // expose methods that can be used in components and services
  trackEvent = (
    event: IEventTelemetry,
    customProperties?: ICustomProperties
  ): void => this.appInsights.trackEvent(event, customProperties)

  trackTrace = (
    trace: ITraceTelemetry,
    customProperties?: ICustomProperties
  ): void => this.appInsights.trackTrace(trace, customProperties)

  trackPageView = (pageView?: IPageViewTelemetry): void =>
    this.appInsights.trackPageView(pageView)

  trackException = (
    exception: IExceptionTelemetry,
    customProperties?: ICustomProperties
  ): void => this.appInsights.trackException(exception, customProperties)

  constructor(private router: Router) { }

  loadAppInsights(appInsightsSettings: AppInsightsSettings): void {
    this.angularPlugin = new AngularPlugin();
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: appInsightsSettings.instrumentationKey,
        extensions: [this.angularPlugin],
        extensionConfig: {
          [this.angularPlugin.identifier]: {
            router: this.router,
            errorServices: [new ErrorHandler()]
          }
        }
      }
    });

    this.appInsights.loadAppInsights();
    this.appInsights.addTelemetryInitializer((envelope) => {
      let itemTags = envelope.tags;
      itemTags = itemTags || [];
      itemTags['ai.cloud.role'] = appInsightsSettings.cloudRoleName;
    });
  }
}
